import { render } from "./AuthorPage.vue?vue&type=template&id=273745dc&scoped=true"
import script from "./AuthorPage.vue?vue&type=script&lang=js"
export * from "./AuthorPage.vue?vue&type=script&lang=js"

import "./AuthorPage.vue?vue&type=style&index=0&id=273745dc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-273745dc"]])

export default __exports__